/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 23.05.2016.
 */

import React, {Component, PropTypes} from 'react';
import {VelocityTransitionGroup} from 'velocity-react';
import DocumentTitle from 'react-document-title';
import {Link} from 'react-router';

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import moment from 'moment';
import Classnames from 'classnames';

import _get from 'lodash/get';
import _at from 'lodash/at';
import _findIndex from 'lodash/findIndex';
import _isEqaul from 'lodash/isEqual';

import {StubFunc, toHumanDay} from '../../utils';

import Translate from '../../components/Translate';
import DivLoader from '../../components/DivLoader';
import ViewSlider from '../../components/ViewSlider';
import Profile from '../../components/ShowcaseCollection/Profile';

import {ACTIONS} from '../../containers/Player';
import {SetPlayer, OpenProfileFor} from '../../actions/common/actions-common';
import {FetchAssetById} from './../../actions/asset/action-asset';
import {GetProgramGuideById, ClearScheduleStore} from './../../actions/schedule/actions-schedule';

class EPGClassicView extends Component {
  constructor(props) {
    super(props);

    this.updateNowInterval = null;
    this.eventFromQuery = {
      id: _get(this.props, 'location.query.e', null),
      start: _get(this.props, 'location.query.start', null)
    };

    this.leaveAnimation = {
      animation: {
        marginTop: '-270px',
        marginBottom: '6px'
      },
      easing: 'ease-in-out',
      duration: 350
    };

    this.enterAnimation = {
      animation: {
        marginTop: 0,
        marginBottom: 0
      },
      easing: 'ease-in-out', duration: 350
    };

    let humanDay = toHumanDay();

    this.state = {
      isToday: false,
      day: moment(),
      start: humanDay.start,
      end: humanDay.end,
      calendar: [],
      picture: `/images/${Config.white_skin ? 'white' : 'black'}/no-channel-logo.png`,
      selectedEvent: null,
      selectedRow: null,
      eventFromQuery: null
    };

  }

  componentWillMount() {
    this.props.ClearScheduleStore([this.props.channelId]);
    this.props.FetchAssetById(this.props.channelId);

    this.props.GetProgramGuideById(this.props.channelId, {
      start: _get(this.state, 'start'),
      end: _get(this.state, 'end')
    });
  }

  componentDidMount() {

    let now = moment().unix();
    let isToday = this.state.start < now && this.state.end > now;

    this.setState({
      isToday: isToday
    });

    if (isToday) {
      if (this.updateNowInterval) clearInterval(this.updateNowInterval);
      this.updateNowInterval = setInterval(() => {

        this.forceUpdate();
      }, 30 * 1000);
    }

    if (this.props.asset.id) lh.models.asset.methods
      .getPosterUrl(this.props.asset, {
        crop: {x: 56, y: 56},
        cache: false
      })
      .then((url) => {
        this.setState({picture: url});
      }, () => {
        this.setState({picture: `/images/${Config.white_skin ? 'white' : 'black'}/no-channel-logo.png`});
      });

    this._createCalendar();

    if (this.props.globalProfile && this.props.globalProfile !== 'epg') {

      this._onCloseEvent();
    }
  }

  componentWillReceiveProps(newProps) {
    let now = moment().unix();
    let isToday = this.state.start < now && this.state.end > now;

    if (this.props.channelId !== newProps.channelId) {

      this.props.ClearScheduleStore([this.props.channelId]);
      this.props.FetchAssetById(newProps.channelId);

      this.props.GetProgramGuideById(newProps.channelId, {
        start: _get(this.state, 'start'),
        end: _get(this.state, 'end')
      });
    }

    if (this.props.globalProfile === 'embedded' && !newProps.globalProfile) {

      this.props.ClearScheduleStore([newProps.channelId]);
      this.props.GetProgramGuideById(newProps.channelId, {
        start: _get(this.state, 'start'),
        end: _get(this.state, 'end')
      });
    }

    if (newProps.asset.id) lh.models.asset.methods
      .getPosterUrl(newProps.asset, {
        crop: {x: 56, y: 56},
        cache: false
      })
      .then((url) => {
        this.setState({picture: url});
      }, () => {
        this.setState({picture: `/images/${Config.white_skin ? 'white' : 'black'}/no-channel-logo.png`});
      });

    this.setState({isToday: isToday});

    if (isToday) {
      if (this.updateNowInterval) clearInterval(this.updateNowInterval);
      this.updateNowInterval = setInterval(() => {

        this.forceUpdate();
      }, 30 * 1000);
    }

    if (_get(newProps, 'program_guide.length') && !_isEqaul(_get(newProps, 'program_guide'), _get(this.props, 'program_guide'))) {

      let eventIndex = -1;

      if (this.eventFromQuery.id && newProps.globalProfile !== 'embedded') {

        eventIndex = _findIndex(_get(newProps, 'program_guide', []), (event) => {

          return _get(event, 'program.id') == this.eventFromQuery.id && event.start == this.eventFromQuery.start;
        });

      } else if (newProps.globalProfile !== 'embedded' && !this.eventFromQuery.id && isToday) {
        let now = moment().unix();

        eventIndex = _findIndex(_get(newProps, 'program_guide', []), (event) => {

          return event.start <= now && (event.start + event.duration) >= now;
        });

      }

      if (eventIndex !== -1) {
        let event = _get(newProps, 'program_guide[' + eventIndex + ']', {});
        let now = moment().unix();

        if (+this.eventFromQuery.start > now) {

          event._forceLive = true;
        }

        this.eventFromQuery = {
          id: null,
          start: null
        };

        setTimeout(() => {

          let $event = document.getElementById('event_' + _get(newProps, 'program_guide[' + eventIndex + '].id', null));

          let eventPosition = $event && ($event.getBoundingClientRect().top);

          this.__scrollToEvent(eventPosition);

          if (this.props.user.user !== 'guest') {

            this._selectEvent(event, eventIndex);
          } else {


          }
        }, 350);
      }
    }

    if (newProps.globalProfile && newProps.globalProfile !== 'epg') {

      this._onCloseEvent();
    }
  }

  componentWillUnmount() {

    if (this.updateNowInterval) clearInterval(this.updateNowInterval);
    this.props.ClearScheduleStore([this.props.channelId]);
  }

  _createCalendar() {

    let now = moment();
    let calendar = [];
    for (let d = -_get(Config, 'epg.epg_window_prev', 4); d <= _get(Config, 'epg.epg_window_next', 7); d++) {

      calendar.push(now.clone().add(d, 'days').hour(6));
    }

    this.setState({calendar: calendar});
  }

  _selectDay(day) {
    this.props.ClearScheduleStore([this.props.channelId]);

    let now = moment().unix();
    let humanDay = toHumanDay(day);

    this._onCloseEvent();

    this.setState({
      day: day,
      isToday: this.state.start < now && this.state.end > now,
      start: humanDay.start,
      end: humanDay.end
    });

    this.props.GetProgramGuideById(this.props.asset.id, {
      start: humanDay.start,
      end: humanDay.end
    });
  }

  _selectEvent(event, row) {
    this.props.SetPlayer({
      stream_url: '',
      container: null,
      action: ACTIONS.CLOSE,
      monitoring: null
    });

    this.setState({
      selectedEvent: event,
      selectedRow: row
    });

    this.props.OpenProfileFor('epg');
  }

  _onCloseEvent() {

    this.setState({
      selectedEvent: null,
      selectedRow: null
    });
  }

  __scrollToEvent(position) {
    if (!position) return;

    var doc = document.documentElement || document.body;
    var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);

    if (top < (position) && this.scrollTop !== top + 200) {

      this.scrollTop = document.body.scrollTop = document.documentElement.scrollTop = top + 200;
      setTimeout(this.__scrollToEvent.bind(this, position), 20);
    }
  }

  _renderCalendar() {

    return this.state.calendar.map((day, index) => {

      let liClass = Classnames({
        'last': index === this.state.calendar.length - 1,
        'day': true,
        'active': toHumanDay(day).start === this.state.start
      });

      let spanClass = Classnames({
        'now-sign': index === _get(Config, 'epg.epg_window_prev')
      });

      return (
        <div key={day.unix()} className={liClass}>
          <a className="pad-lr hover" onClickCapture={this._selectDay.bind(this, day)}>
              <span className="block-note">
                <strong>
                  <span className={spanClass}>
                    {index === _get(Config, 'epg.epg_window_prev') ? <Translate content="epg.today" /> : day.format(_get(Config, 'epg.epg_calendar_day_format', 'D MMM'))}
                  </span>
                </strong>
                {day.format(_get(Config, 'epg.epg_calendar_date_format', 'ddd'))}
              </span>
          </a>
        </div>
      );
    });
  }

  _renderEventIcons(event) {
    let icons = [];

    if (_get(event, 'is_catchup_available') && !_get(event, 'catchup_start_correction')) {
      icons.push(<i key='catchup' className="ic ic-catchup ic-11px pl-"></i>);
    } else if (_get(event, 'event.is_catchup_available') && _get(event, 'catchup_start_correction')) {
      icons.push(<i key='catchup2' className="ic ic-catchup2 ic-11px pl-"></i>);
    }

    if (event.record) {
      icons.push(<i key='record' className="ic ic-rdvr ic-18px pl-" style={{position: 'relative', top: '3px'}}></i>);
    }

    if (event.notification) {
      icons.push(<i key='notification' className="ic ic-notification ic-11px pl "></i>);
    }

    return icons;
  }

  _renderProgramGuide() {
    let now = moment().unix();

    return (<table className="classic-epg radius">
      <tbody>
      {_get(this.props, 'program_guide', []).map((event, index) => {
        event._date = event.start && moment.unix(event.start);
        const metadataClasses = Classnames({
          'time pt pl+': true,
          'color-blue': event.start + event.duration > now && event.start <= now,
          'color-grey': event.start + event.duration < now
        });

        return [
          <tr key={'expand_event_' + (event.id || index)} id="extended-event">
            <td colSpan="2" className="extended-event">
              <VelocityTransitionGroup component={'div'} enter={this.enterAnimation} leave={this.leaveAnimation} runOnMount={true} className={this.state.selectedRow === index && 'pv' || ''}>
                {this.state.selectedRow === index ? <Profile entity={this.state.selectedEvent} channel={_get(this.props, 'asset', {})} onClose={this._onCloseEvent.bind(this)} /> : null}
              </VelocityTransitionGroup>
            </td>
          </tr>
          ,
          this.state.selectedRow !== index &&
          <tr id={'event_' + (event.id || index)} className="row-event">
            <td key="time" className={metadataClasses}>
              {event._date.format(_get(Config, 'epg.epg_event_time_format', 'HH:mm'))}
            </td>
            <td key={'metadata'} className="metadata pv-">
              {event.is_fake ?
                <div className="title no-data p">
                  <Translate content="epg.no_data" />
                  {event.start + event.duration > now && event.start <= now &&
                  <div className="progress">
                    <div className="bar" style={{width: (100 * (now - event.start) / event.duration) + '%'}}></div>
                  </div>
                  }
                </div>
                :
                <div className="metadata-wrapper hover" onClick={this._selectEvent.bind(this, event, index)}>
                  <div className="title">
                    {event.start + event.duration > now && event.start <= now &&
                    <div className="progress">
                      <div className="bar" style={{width: (100 * (now - event.start) / event.duration) + '%'}}></div>
                    </div>
                    }
                    <a href="javascript:void(0)">{event.title || ''}</a>
                    {_get(event, 'title') !== _get(event, 'program.title') && <div className="color-white"> {_get(event, 'program.title', '')} </div>}
                    <div className="icons">{this._renderEventIcons(event)}</div>
                  </div>
                  <div className="description color-grey">{event.description || ''}</div>
                </div>
              }
            </td>
          </tr>
        ];
      })}
      </tbody>
    </table>);
  }

  render() {

    return (<DocumentTitle title={Translate.translator('page.epg') + ' | ' + _get(this.props, 'asset.title', '')}>
        <div>
          <div id="epg-header">
            <div>
              <div className="blocks-row clearfix">
                <div className="blocks-week block menu block-6 radius bg-black">
                  <div className="blocks-week-header radius">
                    <Link to={`/asset/${_get(this.props, 'asset.id')}`}>
                      <ul className="menu block-3 radius bg-black">
                        <li className="block-1 channel-logo--wrapper">
                          <a className="pad-lr hover pointer">
                            <img className="channel-logo--classic-view" src={_get(this.state, 'picture')} alt={_get(this.props, 'asset.title', 'logo')} />
                          </a>
                        </li>
                        <li className="block-1 channel-title--wrapper col-last">
                          <a className="hover pointer">
                        <span className="channel-title--classic-view profile-title">
                          {_get(this.props, 'asset.title')}
                        </span>
                          </a>
                        </li>
                      </ul>
                    </Link>
                  </div>
                  <div className="block-week-days" id="touchcarousel-days">
                    <ViewSlider
                      contentStyle={{width: this.state.calendar.length * 132 + 'px'}}
                      scrollXTo={(_get(Config, 'epg.epg_window_prev') - 1) * 132 - 60}>
                      {this._renderCalendar()}
                    </ViewSlider>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="epg-classic-view radius pv+">
            <DivLoader loading={_get(this.props, 'assetInProgress', false)} />
            <div className="profile-bigtext ml+" style={{fontSize: '36px'}}>
              {_get(this.state, 'day').format(_get(Config, 'epg.epg_day_format', 'D MMMM'))}
            </div>
            <div className="program-guide radius">
              {this._renderProgramGuide()}
            </div>
          </div>
        </div>
      </DocumentTitle>
    );
  };
}

EPGClassicView.defaultProps = {
  categories: [],
  channelId: 0,
  asset: null,
  program_guide: [],
  assetInProgress: false,
  FetchProgramGuide: StubFunc.bind(this, 'FetchProgramGuide')
};

const mapStateToProps = ({auth: {user}, schedule, common: {categories, profile}, assets}, ownProps) => {
  let asset = _get(assets, _get(ownProps, 'channelId', null), {});
  let scheduleForChannel = _get(_get(schedule, 'schedule', {}), _get(ownProps, 'channelId', null), {});
  let eventsForChannel = _at(_get(schedule, 'event', {}), _get(scheduleForChannel, 'schedule', []));

  return {
    globalProfile: profile,
    categories,
    program_guide: eventsForChannel,
    assetInProgress: !!asset.inProgress,
    epgInProgress: !!scheduleForChannel.inProgress,
    asset: asset,
    user: user
  };
};

const mapDispatchToProps = (dispatch) => {

  return bindActionCreators({GetProgramGuideById, FetchAssetById, SetPlayer, OpenProfileFor, ClearScheduleStore}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(EPGClassicView);



// WEBPACK FOOTER //
// ./src/containers/EpgClassicView/epg-classic-view.js